<p *ngIf="text" [innerHTML]="text"></p>
<p *ngIf="!text"><ng-content></ng-content></p>
